import { render, staticRenderFns } from "./activeDistributionApp.vue?vue&type=template&id=3105a6c8&scoped=true"
import script from "./activeDistributionApp.vue?vue&type=script&lang=js"
export * from "./activeDistributionApp.vue?vue&type=script&lang=js"
import style0 from "./activeDistributionApp.vue?vue&type=style&index=0&id=3105a6c8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3105a6c8",
  null
  
)

export default component.exports